<template>
  <div>
    <vh-dialog
      :title="$t('host.k_575001')"
      :visible.sync="dataBaseVisible"
      @close="closeCheckQuestion"
      :modal="false"
      custom-class="select-question"
      width="750px"
    >
      <div class="select-question_wrapper">
        <div class="question-search" v-show="total || isSearch">
          <vh-input
            v-model="keyword"
            :placeholder="$t('host.k_575002')"
            clearable
            @keyup.enter.native="getTitle"
            style="width: 220px"
            @clear="getTitle"
          >
            <i
              slot="prefix"
              class="vh-icon-search vh-input__icon"
              style="cursor: pointer; line-height: 36px"
              @click="getTitle"
            ></i>
          </vh-input>
        </div>
        <div class="question-list" v-show="total || isSearch">
          <vh-table
            :data="tableData"
            ref="tableList"
            style="width: 100%"
            height="320"
            v-loadMore="moreLoadData"
            @selection-change="handleSelectionChange"
            @select-all="checkAllQuestion"
          >
            <!-- 无数据展示 -->
            <template slot="empty">
              <img src="@/app-shared/assets/img/no-search.png" />
              <p>{{ $t('host.k_575003') }}</p>
            </template>
            <vh-table-column type="selection" width="55"></vh-table-column>
            <vh-table-column fixed :label="$t('host.k_575004')">
              <template slot-scope="scope">
                <span class="question-name" :title="scope.row.title">
                  {{ scope.row.title }}
                </span>
              </template>
            </vh-table-column>
            <vh-table-column fixed prop="updated_at" :label="$t('host.k_575005')"></vh-table-column>
            <vh-table-column fixed prop="topic_num" :label="$t('host.k_575006')"></vh-table-column>
            <vh-table-column width="120" fixed :label="$t('host.k_575007')">
              <template slot-scope="scope">
                <span class="show-hover" style="cursor: pointer" @click="preview(scope.row)">
                  {{ $t('host.k_575008') }}
                </span>
              </template>
            </vh-table-column>
          </vh-table>
        </div>
        <div class="question-null" v-show="!total && !(isSearch && total == 0)">
          <span class="null-img"><img src="../../img/no-file.png" alt="" /></span>
          <p>{{ $t('host.k_575009') }}</p>
        </div>
        <div class="question-num" v-show="total || (isSearch && total == 0)">
          <i18n path="host.k_575010" tag="p" class="select-num">
            <template>
              <span>{{ checkList.length }}</span>
            </template>
          </i18n>
          <div slot="footer" class="dialog-footer">
            <vh-button
              round
              size="medium"
              type="primary"
              @click.prevent.stop="choseSureQuestion"
              :disabled="!checkList.length"
              v-preventReClick
            >
              {{ $t('host.k_575011') }}
            </vh-button>
            <vh-button
              round
              size="medium"
              type="info"
              plain
              @click.prevent.stop="closeCheckQuestion"
              v-preventReClick
            >
              {{ $t('host.k_575012') }}
            </vh-button>
          </div>
        </div>
      </div>
    </vh-dialog>
    <vh-dialog
      :title="$t('host.k_575013')"
      :visible.sync="showQuestionVisible"
      @close="showQuestionVisible = false"
      style="overflow: hidden"
      :modal="false"
      width="750px"
    >
      <div id="question-server-box"></div>
    </vh-dialog>
  </div>
</template>
<script>
  import { useQuestionnaireServer } from 'middle-domain';
  export default {
    props: {
      questionList: {
        type: Array,
        default: () => {}
      }
    },
    data() {
      return {
        total: 0,
        isSearch: false, //是否是搜索
        dataBaseVisible: false,
        showQuestionVisible: false, // 预览问卷
        loading: false,
        keyword: '',
        questionId: '',
        checkList: [],
        totalPages: 1,
        tableData: [],
        questionIdList: [],
        isCheckAll: false,
        pageInfo: {
          pageNum: 1,
          pos: 0,
          limit: 10
        }
      };
    },
    components: {},
    beforeCreate() {
      this.questionnaireServer = useQuestionnaireServer({
        uploadUrl: process.env.VUE_APP_BASE_URL,
        mode: 'live'
      });
    },
    mounted() {},
    methods: {
      async openCheckDialog() {
        this.keyword = '';
        this.isCheckAll = false;
        this.pageInfo.pageNum = 1;
        this.pageInfo.pos = 0;
        this.checkList = [];
        this.tableData = [];
        this.dataBaseVisible = true;
        this.questionIdList =
          (this.questionList.length && this.questionList.map(item => Number(item.question_id))) ||
          [];
        this.getTableList();
        return await this.questionnaireServer.loadAndInit({
          mode: 'live',
          locale: this.$i18n.locale === 'en' ? this.$i18n.locale : 'zh'
        });
      },
      closeCheckQuestion() {
        this.pageInfo.pageNum = 1;
        this.pageInfo.pos = 0;
        this.dataBaseVisible = false;
        this.questionIdList = [];
      },
      moreLoadData() {
        if (this.pageInfo.pageNum >= this.totalPages) {
          return false;
        }
        this.pageInfo.pageNum++;
        this.pageInfo.pos = parseInt((this.pageInfo.pageNum - 1) * this.pageInfo.limit);
        this.getTableList();
      },
      getTitle() {
        this.tableData = [];
        this.pageInfo.pageNum = 1;
        this.pageInfo.pos = 0;
        try {
          if (this.$refs.tableList) {
            this.$refs.tableList.clearSelection();
          }
        } catch (e) {
          console.log(e);
        }
        this.getTableList();
      },
      getTableList() {
        let params = {
          exclude_ids: (this.questionIdList.length && this.questionIdList.join(',')) || '',
          keyword: this.keyword || undefined,
          ...this.pageInfo
        };
        this.isSearch = this.keyword ? true : false;
        this.questionnaireServer.getMeterSurveyList(params).then(res => {
          this.loading = false;
          this.total = res.total;
          let list = res?.list || [];
          this.tableData.push(...list);
          if (this.isCheckAll) {
            this.$refs.tableList.toggleAllSelection();
          }
          // if (res.total) {
          //   this.checkList = JSON.parse(JSON.stringify(this.questionList || []));
          //   this.selectedDefaultList(this.questionList);
          // }
          console.log(this.tableData, this.checkList, '55555555555');
          this.totalPages = Math.ceil(res.total / this.pageInfo.limit);
        });
      },
      selectedDefaultList(list) {
        this.$nextTick(() => {
          if (list.length) {
            let selectedList = [];
            selectedList = list.map(item => {
              return item.question_id;
            });
            // 如果返回的列表已经选过，就默认选中
            this.tableData.forEach(item => {
              if (selectedList.includes(item.question_id)) {
                this.$nextTick(() => {
                  this.$refs.tableList.toggleRowSelection(item, true);
                });
              }
            });
          }
        });
      },
      // 选择资料库中的问卷
      choseSureQuestion() {
        if (this.questionIdList.length + this.checkList.length > 100) {
          this.$message({
            message: `${this.$t('host.k_575014')}`,
            showClose: true,
            type: 'error',
            customClass: 'zdy-info-box'
          });
          return;
        }
        this.$emit('addQuestion', this.checkList);
        this.closeCheckQuestion();
      },
      choseShowQueston() {
        this.showQuestionVisible = false;
        this.dataBaseVisible = true;
      },
      // 预览
      preview(rows) {
        console.log('预览', rows);
        this.questionId = rows.question_id;
        this.showQuestionVisible = true;
        // this.dataBaseVisible = false;
        this.$nextTick(() => {
          this.questionnaireServer.renderQuestionnaire4Watch(
            '#question-server-box',
            this.questionId
          );
        });
      },
      checkAllQuestion(selection) {
        // 全选
        this.isCheckAll = selection && selection.length > 0;
        this.checkList = selection;
      },
      // 选中
      handleSelectionChange(val) {
        this.checkList = val;
      }
    }
  };
</script>
<style lang="less">
  .select-question {
    &_wrapper {
      .question-search {
        .vh-input__icon {
          line-height: 36px;
        }
        .vh-input__inner {
          border-radius: 20px;
          height: 36px;
          // padding-right: 30px !important;
        }
        .vh-input__prefix {
          cursor: pointer;
        }
      }
      .question-list {
        // max-height: 320px;
        // overflow: auto;
        margin-top: 12px;
        .vh-table__body-wrapper {
          overflow-x: auto;
          height: 100%;
        }
        &_scroll {
          max-height: 320px;
          overflow: auto;
        }
        .question-name {
          font-size: 14px;
          color: #1a1a1a;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .vh-table th {
          background: #f7f7f7;
          // padding: 15px 0;
        }
        .vh-table td {
          // padding: 15px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        span {
          cursor: pointer;
        }
        .show-hover {
          &:hover {
            color: #fb3a32;
          }
        }
      }
      .question-null {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 100px 0;
        .null-img {
          display: inline-block;
          width: 80px;
          height: 80px;
          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
        }
        p {
          font-size: 14px;
          padding: 10px 0;
        }
      }
      .close-btn {
        z-index: 100;
        position: absolute;
        top: 16px;
        right: 16px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 50%;
        padding: 5px;
        i {
          color: #fff;
          font-size: 20px;
          cursor: pointer;
        }
      }
      .question-num {
        padding-top: 16px;
      }
      .select-num {
        padding-top: 8px;
        font-size: 14px;
        // padding-left: 32px;
        span {
          color: #fb3a32;
          padding: 0 5px;
        }
      }
      .submit-footer {
        text-align: center;
        padding-top: 20px;
      }
      .dialog-footer {
        position: absolute;
        bottom: 14px;
        right: 30px;
      }
    }
  }
</style>
